export default __webpack_public_path__ + "static/media/MIR-UST.0610abd6.svg";